<template>
  <div class="resource-themes-list resource-tile-carousel" :class="cssTheme" v-if="contentIsLoaded">
    <div class="id-anchor" :id="title" />
    <div class="container">
      <slot name="title"
        ><h3>{{ title }}</h3></slot
      >
    </div>
    <cs-carousel>
      <cms-tile :key="link.id" v-for="link in links" :class="tileCssClass" :link="link"> </cms-tile>
    </cs-carousel>

    <div style="width: 50px"></div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { debug as d } from "debug";
import cms from "../../services/cms/cms";
import RenderWaiter from "../../services/utilities/render-waiter";
import {
  CmsResourceRelationship,
  CmsResourceTheme,
  CmsResourceThemesPage,
} from "../../services/cms/cms-type-definitions";
import CmsTile from "./cms-tile.vue";
import CsCarousel from "../carousels/cs-carousel.vue";

const debug = d("cs.CmsThemesList");

const props = withDefaults(
  defineProps<{
    doc: CmsResourceThemesPage;
    tileCssClass: string;
    cssTheme: string;
  }>(),
  {
    tileCssClass: "",
    cssTheme: "record-sleeve-theme",
  },
);

const renderWaits = ref<string[]>([]);

const renderWaiter = new RenderWaiter(renderWaits.value);

const title = computed(() => cms.asText(props.doc?.data.title));

const links = computed<CmsResourceRelationship[]>(
  () => props.doc?.data?.items?.map((i) => i.link) ?? [],
);

const contentIsLoaded = computed(() => !!props.doc && renderWaits.value.length === 0);
</script>
